<template>
    <div id="step-5" class="step step-5 step-finished" v-if="finished">
        <img src="/svg/sms/campaign-success.svg" width="250px" />
        <p>Parabéns, Sua campanha foi criada com sucesso!</p>
        <mu-button round color="#999" :to="{ name: 'app.services.sms' }">
            <font-awesome-icon icon="eye" class="icon-md icon-margin-left"/>
            Ver Campanhas
        </mu-button>
    </div>
</template>

<script>
    export default {
        name: 'campaign-step-5',
        props: ['finished']
    }
</script>

<style lang="stylus" scoped>

    @import './../../../assets/stylus/bootstrap.styl'

    .step-finished
        max-width 600px
        margin auto
        padding 50px 0
        text-align center
        font-size 14px
        color #999

</style>
